import { WithTranslation } from 'react-i18next';
import { History } from '@dev/history';

import { BrowserInterface } from '@/store';

import { AccountState } from '@/store/account/types';
import { DomainState } from '@/store/domain/types';
import { ConfigState } from '@/store/config/types';
import { WebhooksState } from '@/store/webhooks/types';
import { InboundState } from '@/store/inboundRoutes/types';
import { ProductListState } from '@/store/products/types';
import { PaymentsState } from '@/store/payments/types';
export interface HomeProps extends WithTranslation {
    classes: any;
    history: History;
    location: any;
    account?: AccountState;
    browser?: BrowserInterface;
    domain: DomainState;
    webhooks: WebhooksState;
    inbound: InboundState;
    config: ConfigState;
    products: ProductListState;
    payments: PaymentsState;
}

export enum WidgetType {
    SUBDOMAIN = 'subdomain',
    LINK_IN_BIO = 'linkInBio',
    CAMPAIGNS = 'campaigns',
    CONTACTS_GROWTH = 'contactsGrowth'
}

export const WIDGETS_ORDER = [
    WidgetType.SUBDOMAIN,
    WidgetType.LINK_IN_BIO,
    WidgetType.CAMPAIGNS,
    WidgetType.CONTACTS_GROWTH
] as const;

interface WidgetButton {
    textKey?: string;
    onClick?: () => void;
}
export interface WidgetConfig {
    title: string;
    content: JSX.Element;
    button?: WidgetButton;
    isButtonVisible?: boolean;
    isLoading: boolean;
    useCustomContentLayout?: boolean;
}

export interface WidgetMap {
    [WidgetType.SUBDOMAIN]: WidgetConfig;
    [WidgetType.LINK_IN_BIO]: WidgetConfig;
    [WidgetType.CAMPAIGNS]: WidgetConfig;
    [WidgetType.CONTACTS_GROWTH]: WidgetConfig;
}

export type Props = HomeProps;

export default HomeProps;
